import { http, HttpResponse } from "msw";

import { ASSOCIATIONS_RESPONSE } from "../data/associations";
import { CHARGEBOX_RESPONSE } from "../data/charge-boxes";
import { ENUMS_RESPONSE } from "../data/enums";
import { EXPORT_STATUSES_RESPONSE } from "../data/export-statuses";
import { SEEDED_LOCATION } from "../data/locations";
import { SEEDED_ORDER_LOCATION_ID } from "../data/orders";

/**
 * msw handlers for tech-ui-owned endpoints. tech-ui is developed in another
 * repo but executes inside the router document, so this worker intercepts
 * its tech-api calls too (adr/0003). Wildcard prefixes match regardless of
 * the base URL each app was built with.
 *
 * Covers the tech-ui app shell (`/enums/`, `/charge-record/exportStatuses/`,
 * `/companies/v2/:id`) and the `/order-lookup` -> `/location-edit/:id` flow
 * (`/order/:id`, `/locations/:id`, `/associations`, `/chargebox`).
 */
const techUiHandlers = [
  http.get("*/enums/", () => HttpResponse.json(ENUMS_RESPONSE)),

  http.get("*/charge-record/exportStatuses/", () =>
    HttpResponse.json(EXPORT_STATUSES_RESPONSE)
  ),

  // tech-ui app shell: company lookup for the token's permittedCompanyId.
  http.get("*/companies/v2/:companyId", ({ params }) =>
    HttpResponse.json({ id: params.companyId, name: "Test Company" })
  ),

  http.get("*/order/:orderId", () =>
    HttpResponse.json({ locationId: SEEDED_ORDER_LOCATION_ID })
  ),

  http.get("*/locations/:locationId", ({ params }) =>
    HttpResponse.json({
      ...SEEDED_LOCATION,
      id: Number(params.locationId),
    })
  ),

  http.get("*/associations", () => HttpResponse.json(ASSOCIATIONS_RESPONSE)),

  http.get("*/chargebox/", () => HttpResponse.json(CHARGEBOX_RESPONSE)),
];

export { techUiHandlers };
